<script>
import VImg from 'vuetify/lib/components/VImg'

// this wrapper to not console the error
export default VImg.extend({
  name: 'VImageWrapper',
  methods: {
    onError() {
      this.$emit('error')
    }
  }
})
</script>
